module.exports = __webpack_public_path__ + "img/51567fb.png";